import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { PRODUCTS } from '../data/mock';
import SectionHeading from './SectionHeading';
import { useQuote } from '../context/QuoteContext';

const Products = () => {
  const { openQuote } = useQuote();
  return (
    <section id="products" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="What We Make"
          title="Our Signature"
          accent="Products"
          subtitle="Personalised, hand-finished, event-ready — every item we ship is built to be photographed and remembered."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PRODUCTS.map((p, i) => (
            <article
              key={p.slug}
              className="coco-card group relative overflow-hidden rounded-3xl bg-white border border-pink-100 shadow-soft flex flex-col"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`product-card-${p.slug}`}
            >
              <Link to={`/products/${p.slug}`} className="relative aspect-[4/3] overflow-hidden bg-blush block" data-testid={`product-image-${p.slug}`}>
                <img
                  src={p.hero}
                  alt={p.name}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/0 to-transparent" />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1 bg-white/95 text-pink-brand text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full shadow-sm">
                  <Sparkles className="w-3 h-3" /> Signature
                </span>
              </Link>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display font-semibold text-xl text-stone-900 leading-tight">{p.name}</h3>
                <p className="text-sm text-stone-500 mt-1 italic">{p.tagline}</p>
                <p className="text-sm text-stone-600 mt-3 line-clamp-3 flex-1">{p.short}</p>
                <div className="mt-5 flex items-center gap-3">
                  <Link
                    to={`/products/${p.slug}`}
                    className="inline-flex items-center gap-1 text-sm font-semibold text-pink-brand hover:gap-2 transition-all"
                    data-testid={`product-view-${p.slug}`}
                  >
                    View page <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                  <span className="w-px h-4 bg-stone-200" />
                  <button
                    type="button"
                    onClick={() => openQuote({ event_type: p.name, source: `products-${p.slug}` })}
                    className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-900 transition-colors"
                    data-testid={`product-enquire-${p.slug}`}
                  >
                    Enquire <ArrowRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/products"
            className="inline-flex items-center gap-1.5 text-pink-brand font-semibold hover:gap-2 transition-all bg-blush/60 hover:bg-blush rounded-full px-6 py-3"
            data-testid="products-view-all-link"
          >
            View all products <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Products;
